<template>
  <div class="teaser-advanced" v-if="visible">
    <div class="image-wrap">
      <img :src="element.teaserImage"
           :title="element.title"
           :alt="element.title"
           @error="setDefaultImage"
           class="offer-image"
           width="473"
           height="260"
      />
      <span class="divider-gradient"></span>


      <order-number :ordernumber="element.orderNumber"
                    :bookablefrom="element.bookableFrom"
                    :bookableto="element.bookableTo"></order-number>

      <div class="offer-details">
        <div class="adt" v-if="detail.isAdw">
          <img v-bind:src="staticAdw"
               alt="adW-icon">
        </div>
        <div class="adt" v-if="detail.Adt">
          <img v-bind:src="staticAdt"
               alt="adT-icon">
        </div>
        <div class="counter-wrap" v-if="detail.counterVisible">
          <offer-detail-counter :endtime="endTime"
                                :ordernumber="detail.orderNumber"/>
        </div>
      </div>
    </div>
    <div class="body-wrap">
      <price :price="element.price"></price>
      <div class="title">
        <h2 class="line-clamp"
            :title="detail.title">{{ detail.title }}<span class="sun" v-html="detail.renderedCategory"></span></h2>
      </div>

      <p class="location"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ detail.destination }}</p>

      <rating :rating="detail.rating"></rating>

      <div v-if="detail.advantages" class="advantages-content">
        <p class="list-title"><strong>Ihre besonderen sonnenklar.TV Vorteile</strong></p>
        <div class="advantages-list" v-html="detail.advantages"></div>
        <div class="overlay"></div>
      </div>

      <p class="bookable-to">
        <i class="fa fa-exclamation-triangle"></i>&nbsp;
        <strong>Buchbar nur bis {{ onlineTo }}</strong>
      </p>


    </div>
    <div class="btn-wrap">
      <p class="tipping" v-if="detail.detailTipping" v-html="detail.detailTipping"></p>
      <a class="btn btn-success btn-teaser-cta"
         :href="detail.urlIbe"
         target="_blank"
         title="Alle Details zum Angebot">
        ZU DEN TERMINEN
      </a>
    </div>
  </div>
</template>

<script>
import OfferDetailCounter from "./OfferDetailCounter.vue";
import OrderNumber from "./Teaser/OrderNumber.vue";
import Rating from "./Teaser/Rating.vue";
import Price from "./Teaser/Price.vue";

import axios from 'redaxios/dist/redaxios';

export default {
  name: 'TeaserLiveTv',
  data() {
    return {
      element: {},
      detail: {},
      visible: false,
    }
  },
  created() {
    this.fetchData();
    if (parseInt(this.$attrs.interval) > 0)
      setInterval(() => this.fetchData(), parseInt(this.$attrs.interval));
  },
  components: {
    OfferDetailCounter,
    OrderNumber,
    Rating,
    Price
  },
  computed: {
    onlineTo() {
      let date = new Date(this.fixDateString(this.detail.onlineTo.date));
      return ('' + date.getDate()).padStart(2, '0') + '.' + ('' + (date.getMonth() + 1)).padStart(2, '0') + '.' + date.getFullYear();
    },
    endTime() {
      let date = new Date(this.fixDateString(this.detail.onlineTo.date));
      return Math.floor(date.getTime() / 1000);
    },
    staticAdt() {
      return mediathekPublicAssetsPath + 'Images/AdT-Stoerer.png';
    },
    staticAdw() {
      return mediathekPublicAssetsPath + 'Images/AdW-Stoerer.png';
    },
  },
  methods: {
    fetchData() {
      axios.get(this.$attrs.uri)
          .then(response => {
            if (response.status === 200) {
              this.element = response.data.element;
              this.detail = response.data.detail;
              this.visible = true;
              return;
            }
            this.visible = false;
          })
          .catch(error => {
            this.visible = false;
            console.log('🌞',error);
          });
    },
    setDefaultImage(evt) {
      evt.target.src = mediathekPublicAssetsPath + "Images/defaultimage_small.jpg";
    }
  }
}
</script>

<style lang="scss">
</style>